import { render, staticRenderFns } from "./AttendanceChatExpired.vue?vue&type=template&id=17b99503&scoped=true"
import script from "./AttendanceChatExpired.vue?vue&type=script&lang=js"
export * from "./AttendanceChatExpired.vue?vue&type=script&lang=js"
import style0 from "./AttendanceChatExpired.vue?vue&type=style&index=0&id=17b99503&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b99503",
  null
  
)

export default component.exports